"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertSmtpDebugToggle = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dmsbasereact = require("dmsbasereact");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AlertSmtpDebugToggle = _ref => {
  let {
    showConfiguredNote = true,
    onToggle,
    size = "medium",
    color = "warning"
  } = _ref;
  const [loading, setLoading] = (0, _react.useState)(true);
  const [saving, setSaving] = (0, _react.useState)(false);
  const [debugMode, setDebugMode] = (0, _react.useState)(false);
  const [configured, setConfigured] = (0, _react.useState)(false);
  const fetchDebugMode = (0, _react.useCallback)(async () => {
    setLoading(true);
    try {
      var _response$data;
      const response = await (0, _dmsbasereact.fetchData)("/alert_smtp_settings/debug-mode", "GET", true);
      const data = (response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) || (response === null || response === void 0 ? void 0 : response.data) || {};
      setDebugMode(data.debug_mode || false);
      setConfigured(data.configured || false);
    } catch (error) {
      _dmsbasereact.Notifications.toast(_dmsbasereact.intl.get("AlertSmtpSettings.FetchError").d("Failed to load debug mode status"), "error");
    } finally {
      setLoading(false);
    }
  }, []);
  (0, _react.useEffect)(() => {
    fetchDebugMode();
  }, [fetchDebugMode]);
  const handleToggle = async () => {
    const newValue = !debugMode;
    setSaving(true);
    try {
      var _response$data2;
      const response = await (0, _dmsbasereact.fetchData)("/alert_smtp_settings/debug-mode", "PUT", true, {
        debug_mode: newValue
      });
      const data = (response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.data) || (response === null || response === void 0 ? void 0 : response.data) || {};
      if (data.success || response.status === _dmsbasereact.HTTP_STATUS.OK_200) {
        setDebugMode(newValue);
        _dmsbasereact.Notifications.toast(newValue ? _dmsbasereact.intl.get("AlertSmtpSettings.DebugEnabled").d("Alert email debug enabled") : _dmsbasereact.intl.get("AlertSmtpSettings.DebugDisabled").d("Alert email debug disabled"), "success");
        if (onToggle) {
          onToggle(newValue);
        }
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      _dmsbasereact.Notifications.toast(_dmsbasereact.intl.get("AlertSmtpSettings.UpdateError").d("Failed to update debug mode"), "error");
    } finally {
      setSaving(false);
    }
  };
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 1
      }
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
      size: 20
    }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2",
      color: "text.secondary"
    }, _dmsbasereact.intl.get("AlertSmtpSettings.Loading").d("Loading...")));
  }
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_material.Switch, {
      checked: debugMode,
      onChange: handleToggle,
      disabled: saving,
      color: color,
      size: size
    }),
    label: /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, debugMode ? _dmsbasereact.intl.get("AlertSmtpSettings.StatusEnabled").d("Alerts printed to console") : _dmsbasereact.intl.get("AlertSmtpSettings.StatusDisabled").d("Alerts sent by email"))
  }), showConfiguredNote && !configured && /*#__PURE__*/_react.default.createElement(_material.Alert, {
    severity: "info",
    sx: {
      mt: 1
    }
  }, _dmsbasereact.intl.get("AlertSmtpSettings.NotConfiguredNote").d("Note: Alert SMTP is not configured. Configure it in the Communication tab to send emails.")));
};
exports.AlertSmtpDebugToggle = AlertSmtpDebugToggle;
AlertSmtpDebugToggle.propTypes = {
  showConfiguredNote: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  size: _propTypes.default.oneOf(["small", "medium"]),
  color: _propTypes.default.string
};